import { useMemo } from 'react'
import { EmissionTier, emissionTierOptions } from './index'
import ClimateSegmentedField from './ClimateSegmentedField'

type EmissionTierSelectorProps = {
  value: EmissionTier
  onChange: (tier: EmissionTier) => void
  label?: string
}

const tierLabels: Record<EmissionTier, string> = {
  [EmissionTier.LOW]: 'Low',
  [EmissionTier.MODERATE]: 'Moderate',
  [EmissionTier.HIGH]: 'High',
}

const EmissionTierSelector = ({ value, onChange, label = 'Emissions' }: EmissionTierSelectorProps) => {
  const options = useMemo(
    () => emissionTierOptions.map(option => ({ value: option.name, label: tierLabels[option.name] })),
    [],
  )

  return (
    <ClimateSegmentedField
      label={label}
      helpText="Changes the projected emissions pathway used across the climate results on this page."
      value={value}
      onChange={next => onChange(next as EmissionTier)}
      options={options}
      ariaLabel="GHG emission scenario"
    />
  )
}

export default EmissionTierSelector
